import $ from "jquery";

/** get the matchmaking questions as a promise */
const getMatchmakingQuestions = async (submitButton: JQuery<HTMLElement>): Promise<AventriQuestionDetail[] | AventriQuestionDetail[][]> => {
  return new Promise((resolve, reject) => {
    let mmQuestionsDetails: AventriQuestionDetail[] = [];
    let mmQuestionsDetailsMBO: AventriQuestionDetail[][] = [];
    let { matchmaking } = window.RAC.config.aventriFields;
    matchmaking.forEach(async (mmField, index) => {
      if (window.RAC.config.mboRecommendations && Array.isArray(mmField)) {
        let mmQuestionsObjective: AventriQuestionDetail[] = [];
        mmField.forEach(async (field) => {
          try {
            mmQuestionsObjective.push(await window.RAC.exhibition.get_aventri_question_details(field));
          } catch (error) {
            console.error(error);
            /** enable button */
            jQuery("input[name='reg_button'][type='submit']").removeClass("disabledButton");
            /** reject promise with error message */
            reject("ARR - Error getting aventri question");
          }
        });
        //
        mmQuestionsDetailsMBO.push(mmQuestionsObjective);
        if (index === matchmaking.length - 1) resolve(mmQuestionsDetailsMBO);
      } else {
        try {
          mmQuestionsDetails.push(await window.RAC.exhibition.get_aventri_question_details(mmField));
          if (index === matchmaking.length - 1) resolve(mmQuestionsDetails);
        } catch (error) {
          console.error(error);
          /** enable button */
          jQuery("input[name='reg_button'][type='submit']").removeClass("disabledButton");
          /** reject promise with error message */
          reject("ARR - Error getting aventri question");
        }
      }
    });
  });
};

/** return a checked input jquery selector - `input[id*=${id}]:checked` */
const checked = (id: string | number): string => `input[id*=${id}]:checked`;

/**
 * handle submiting getting recommendations and registring the attendee to atlas
 * @param mmQuestionsDetails mmQuestionsDetails
 * @param aventriAttendee the aventri attendee response
 */
const handleClickSubmit = async (
  mmQuestionsDetails: AventriQuestionDetail[] | AventriQuestionDetail[][],
  aventriAttendee: AventriAttendee,
  logObject: LogObject
) => {
  /** time */
  console.time("ARR - Handling Submit Time");

  /** start logging */
  logObject.messages.push("ARR - Handling form submit");

  /** set loading true */
  window.RAC.loading.set_state(true);
  window.RAC.loading.set_message("Lendo perguntas");

  /** make recommendations On Demand ids list */
  let matchmakingSelectionList: string = "";

  /** matchmaking counting */
  let mmCount = 0;

  /** check for mbo recommendations */
  if (window.RAC.config.mboRecommendations) {
    logObject.messages.push("ARR - Using MBO Recommendations");
    console.log("ARR - Using MBO Recommendations");

    /** get matchmaking responses from question details */
    mmQuestionsDetails.forEach((mmQuestion: AventriQuestionDetail[]) => {
      /** WE WILL ASSUME THAT WE HAVE INDEXES 0 AND 1 WHEN USING MBO */
      let firstQuestionsSelection = $(checked(mmQuestion[0].questionid));
      let secondQuestionsSelection = $(checked(mmQuestion[1].questionid));

      if (firstQuestionsSelection.length > 0 && secondQuestionsSelection.length > 0) {
        /** count both mbo questions as one */
        mmCount++;

        /** mount crossing list all possibilities */
        let objectiveTexts: string[] = [];
        firstQuestionsSelection.each((i, fSelection) => {
          let fSelectionId = fSelection.id.split("_")[2];
          let fRelatedChoice = mmQuestion[0].choices.find((choice) => choice.choicekey === fSelectionId);
          if (fRelatedChoice) {
            let fSelectionMatchId = fRelatedChoice.reportname.split("_")[0];

            secondQuestionsSelection.each((i, sSelection) => {
              let sSelectionId = sSelection.id.split("_")[2];
              let sRelatedChoice = mmQuestion[1].choices.find((choice) => choice.choicekey === sSelectionId);
              if (sRelatedChoice) {
                let sSelectionMatchId = sRelatedChoice.reportname.split("_")[0];
                objectiveTexts.push(`{ answerIds: ["${fSelectionMatchId}", "${sSelectionMatchId}"] }`);
              }
            });
          }
        });
        objectiveTexts.forEach((text) => {
          matchmakingSelectionList += `${text}, `;
        });
      }

      // /** get question selections */
      // let questionSelections = $(checked(mmQuestion.questionid));
      // /** check for selection */
      // if (questionSelections.length > 0) {
      //   /** count mm */
      //   mmCount++;
      //   /** get related choices from selections and mount matchmakingSelectionList string */
      //   questionSelections.each((i, selection) => {
      //     let selectionId = selection.id.split("_")[2];
      //     let relatedChoice = mmQuestion.choices.find((choice) => choice.choicekey === selectionId);
      //     /** check for related choice */
      //     if (relatedChoice) {
      //       matchmakingSelectionList += `"${relatedChoice.reportname.split("_")[0]}", `;
      //     }
      //   });
      // }
    });

    /** remove last comma and space from selections string */
    matchmakingSelectionList = `[ ${matchmakingSelectionList.slice(0, -2)} ]`;

    // -----------------------------------------
  } else {
    logObject.messages.push("ARR - Using Legacy Recommendations");
    console.log("ARR - Using Legacy Recommendations");

    /** get matchmaking responses from question details */
    mmQuestionsDetails.forEach((mmQuestion: AventriQuestionDetail) => {
      /** get question selections */
      let questionSelections = $(checked(mmQuestion.questionid));
      /** check for selection */
      if (questionSelections.length > 0) {
        /** count mm */
        mmCount++;
        /** get related choices from selections and mount matchmakingSelectionList string */
        questionSelections.each((i, selection) => {
          let selectionId = selection.id.split("_")[2];
          let relatedChoice = mmQuestion.choices.find((choice) => choice.choicekey === selectionId);
          /** check for related choice */
          if (relatedChoice) {
            matchmakingSelectionList += `"${relatedChoice.reportname.split("_")[0]}", `;
          }
        });
      }
    });

    /** remove last comma and space from selections string */
    matchmakingSelectionList = `[ { answerIds: [ ${matchmakingSelectionList.slice(0, -2)} ] } ]`;
  }

  /** log */
  logObject.messages.push("ARR - Read MM Questions");
  logObject.mmQuestions = { count: mmCount };
  console.log({ mmCount, mmQuestionsDetails });

  /** check if matchmaking selection has answers for all questions */
  if (mmCount === mmQuestionsDetails.length) {
    /** contact responses ids */
    let { rejectContact, rejectReedOptions, rejectEventOptions, rejectThirdPartyContact } = window.RAC.config.aventriFields;

    /** get reject contact responses */
    let reedContactSelection = $(checked(rejectContact));
    let thirdPartyContactSelection = $(checked(rejectThirdPartyContact));

    /** mount rejectContact object */
    let rejectObject: RejectContactObject = {
      event: {
        email: false,
        phone: false,
        sms: false,
        message: false,
      },
      reed: {
        email: false,
        phone: false,
        sms: false,
        message: false,
      },
      thirdParty: false,
    };

    /** check reed contact selection */
    if (reedContactSelection.length > 0) {
      /** get opt-out selections for reed contact */
      let reedOptionsSelection = $(checked(rejectReedOptions));
      if (reedOptionsSelection.length > 0) {
        reedOptionsSelection.each((index) => {
          switch (reedOptionsSelection[index].id.split("_")[2]) {
            case "1":
              rejectObject.reed.email = true;
              break;
            case "2":
              rejectObject.reed.phone = true;
              break;
            case "3":
              rejectObject.reed.sms = true;
              break;
            case "4":
              rejectObject.reed.message = true;
              break;
          }
        });
      }
      /** get opt-out selections for reed contact */
      let eventOptionsSelection = $(checked(rejectEventOptions));
      if (eventOptionsSelection.length > 0) {
        eventOptionsSelection.each((index) => {
          switch (eventOptionsSelection[index].id.split("_")[2]) {
            case "1":
              rejectObject.event.email = true;
              break;
            case "2":
              rejectObject.event.phone = true;
              break;
            case "3":
              rejectObject.event.sms = true;
              break;
            case "4":
              rejectObject.event.message = true;
              break;
          }
        });
      }
    }

    window.RAC.loading.set_message("Generating Atlas Recommendations");
    logObject.messages.push("ARR - Generating Atlas Queries");
    console.log("ARR - Generating Atlas Queries");
    console.log({ matchmakingSelectionList });

    /** check third party contact selection */
    if (thirdPartyContactSelection.length > 0) rejectObject.thirdParty = true;

    /** get visitor registration query */
    let atlasVisitorRegistrationQuery: string = window.RAC.transformers.aventri_attendee_to_atlas_reg_query(
      aventriAttendee,
      matchmakingSelectionList,
      rejectObject
    );

    /** get visitor recommendations query - check mbo first */
    let atlasVisitorRecommendationQuery: string = window.RAC.transformers.aventri_attendee_atlas_recommendations_query(
      matchmakingSelectionList
    );

    /** log queries */
    // console.log(atlasVisitorRegistrationQuery);
    // console.log(atlasVisitorRecommendationQuery);
    logObject.queries = {
      registration: atlasVisitorRegistrationQuery,
      recommendation: atlasVisitorRecommendationQuery,
    };

    /** Log */
    logObject.messages.push("ARR - Requesting Recommendations");

    /** response to atlas recommendations call */
    let recommendationsResponse = await window.RAC.attendee.get_attendee_recommendations_retry(
      atlasVisitorRecommendationQuery,
      window.RAC.config.atlasStaging,
      3
    );

    console.log({ recommendationsResponse, atlasVisitorRecommendationQuery });

    /** check for response */
    if (Array.isArray(recommendationsResponse)) {
      /** log recommendations response */
      logObject.recommendations = recommendationsResponse;
      window.RAC.loading.set_message("Registring Visitor on Atlas");
      logObject.messages.push("ARR - Requesting Visitor Registration");
      /** try call atlas registration */
      try {
        let registrationId = "";
        let registerResponse; // TODO fiz registration response type any
        if (!window.testingForm) {
          /** THIS IS NOT A TEST - do visitor registration */
          console.log({atlasVisitorRegistrationQuery});
          registerResponse = await window.RAC.attendee.register_atlas_attendee(
            atlasVisitorRegistrationQuery,
            window.RAC.config.atlasStaging
          );
          console.log({ registerResponse, atlasVisitorRegistrationQuery });
          registrationId =
            registerResponse.data &&
            registerResponse.data.createVisitorRegistration &&
            registerResponse.data.createVisitorRegistration.registrationId
              ? registerResponse.data.createVisitorRegistration.registrationId
              : null;
        } else {
          // testing form - skip registration
          registrationId = "b7467c82-f45f-4cd2-9058-d13814627839";
        }
        /** check for registration id */
        if (!registrationId) {
          // something went wrong
          var errorCode = registerResponse.errors ? registerResponse.errors[0].message : "";
          if (!errorCode) errorCode = "Registration returned NULL id";
          /** change loading text and state */
          logObject.messages.push("ARR - Error registring visitor on Atlas");
          logObject.error = ""; //errorCode;
          console.error(
            "ARR - Error registring visitor on Atlas" + "\nError From Atlas: " //+ errorCode
          );
        } else {
          // /** fake registration wait time */
          // setTimeout(() => {
          /** */
          /** has registrationId */
          console.log(registrationId);
          logObject.messages.push("ARR - Visitor Registred, filling hidden form");
          logObject.registrationId = registrationId;

          // console.log(atlasVisitorRegistrationQuery);
          if (Array.isArray(recommendationsResponse)) {
            window.RAC.loading.set_message("Preenchendo Inputs");

            /** save reco to fields */
            recommendationsResponse.forEach((recommendation, index) => {
              let currentField = window.RAC.config.aventriFields.recommendationsFields[index];
              let field_a = $(`input[id*=${currentField.a}]`);
              let field_b = $(`input[id*=${currentField.b}]`);
              let field_c = $(`input[id*=${currentField.c}]`);
              let field_d = $(`input[id*=${currentField.d}]`);
              let field_e = $(`input[id*=${currentField.e}]`);
              let field_f = $(`input[id*=${currentField.f}]`);

              let rec_title = window.RAC.transformers.get_atlas_multilingual_property(
                "title",
                window.RAC.config.locale,
                recommendation.multilingual
              );
              let rec_stand = recommendation.stands[0] ? recommendation.stands[0].name : "";
              let rec_description = window.RAC.transformers.get_atlas_multilingual_property(
                "description",
                window.RAC.config.locale,
                recommendation.multilingual
              );
              let rec_link = window.RAC.transformers.get_atlas_multilingual_property(
                "link",
                window.RAC.config.locale,
                recommendation.multilingual
              );
              let rec_logo =
                window.RAC.transformers.get_atlas_multilingual_property("logo", window.RAC.config.locale, recommendation.multilingual) ||
                window.RAC.config.defaultAvatar;
              let rec_id = recommendation.id;

              field_a.val(rec_title);
              field_b.val(rec_stand);
              field_c.val(rec_description);
              field_d.val(rec_link);
              field_e.val(rec_logo);
              field_f.val(rec_id);
            });

            let registrationIdField = $(`input[id*=${window.RAC.config.aventriFields.atlasRegistrationId}]`);
            let recommendationsBlockField = $(`textarea[id*=${window.RAC.config.aventriFields.atlasRecommendationsBlock}]`);
            let logField = $(`textarea[id*=${window.RAC.config.aventriFields.logs}]`);
            let statusField = $(`input[id*=${window.RAC.config.aventriFields.integrationStatus}]`);

            /** get recommendations block */
            let recommendationBlockHtml = window.RAC.transformers.recommendations_to_html(recommendationsResponse);

            logObject.recoBlock = recommendationBlockHtml;

            registrationIdField.val(registrationId);
            recommendationsBlockField.val(recommendationBlockHtml);
            logField.val(JSON.stringify(logObject));
            statusField.val(logObject.status);

            /** submit form */
            console.log("ARR - Submiting form");
            window.RAC.loading.set_message("Submiting Form");
            logObject.status = "OK";
            logObject.messages.push("ARR - Submiting form.");
            logObject.error = "";
            /** time */
            console.timeEnd("ARR - Handling Submit Time");
            console.log({ logObject });
            if (!window.blockForm) $("form").submit();
            if (window.blockForm) {
              console.log(`ARR - FORM BLOCKED - SUBMIT WAS NOT MADE - $("form").submit()`);
              window.testingForm
                ? console.log(`ARR - FORM TESTING - REGISTRATION WAS FAKE`)
                : console.log(`ARR - FORM NOT TESTING - REGISTRATION WAS REAL`);
              window.RAC.loading.set_state(false);
            }
            if (window.testingForm && !window.blockForm) {
              console.log(`ARR - FORM ON TEST MODE - SUBMIT WAS MADE - REGISTRATION IS FAKE`);
            }
          }
          /** */
          // }, 600);
        }
      } catch (error) {
        console.warn("ARR - Error registring attendee on Atlas", error);
        logObject.status = "ERROR_REGISTRING_ATLAS_VISITOR";
        logObject.messages.push("ARR - Error while registring Atlas visitor");
        logObject.error = error;
      }
    } else {
      console.warn("ARR - Error requesting recommendations");
      logObject.status = "ERROR_REQUESTING_RECOMMENDATIONS";
      logObject.messages.push("ARR - Error requesting recommendations");
      logObject.error = recommendationsResponse.errorMessage;
    }
  } else {
    console.log("ARR - MISSING SELECTION");
    console.log("ARR - AVENTRI WILL BLOCK FORM AND RELOAD THE PAGE.");
    window.RAC.loading.set_state(false);
    if (!window.blockForm) $("form").submit();
    if (window.blockForm) {
      console.log(`ARR - FORM BLOCKED - SUBMIT WAS NOT MADE - REGISTRATION IS REAL - $("form").submit()`);
      window.RAC.loading.set_state(false);
    }
    if (window.testingForm) {
      console.log(`ARR - FORM ON TEST MODE - SUBMIT WAS MADE - REGISTRATION IS FAKE`);
    }
  }
};

/** ASYNC AUTO-EXECUTABLE SCRIPT */
(async () => {
  /** check for library loaded and ATTENDEE_ID from snippet */
  if (window.RAC.loaded && window.ATTENDEE_ID) {
    /** start log object */
    let logObject: LogObject = {
      messages: [],
      status: "OK",
    };

    /** log start */
    // let startMessage = "ARR - Atlas Recommendations Registration - Script Loaded.";
    let startMessage = "ARR - Script Loaded.";
    logObject.messages.push(startMessage);
    console.log(startMessage);

    /** submit button */
    let submitButton = jQuery("input[name='reg_button'][type='submit']");

    /** get current page */
    let currentPageNumber = jQuery("input[name=pagesection]").val();

    /** check page to generate recommendations */
    if (currentPageNumber == window.RAC.config.pageToGenerateRecommendation) {
      /** try to get mm questions details */
      try {
        /** disable button while getting questions and attendee */
        jQuery("input[name='reg_button'][type='submit']").addClass("disabledButton");

        /** get mmQuestions */
        let mmQuestionsDetails: AventriQuestionDetail[] | AventriQuestionDetail[][] = await getMatchmakingQuestions(submitButton);

        /** try to get attendee */
        try {
          /** get the attendee from aventri */
          let aventriAttendee: AventriAttendee = await window.RAC.attendee.get_aventri_attendee(window.ATTENDEE_ID);
          /** enable button */
          jQuery("input[name='reg_button'][type='submit']").removeClass("disabledButton");
          /** handle submit click */
          jQuery("input[name='reg_button'][type='submit']").on("click", async (event: Event) => {
            /** prevent sending of form */
            event.preventDefault();
            /** call handle submit with mmQuestionsDetails */
            handleClickSubmit(mmQuestionsDetails, aventriAttendee, logObject);
          }); // end Click handler
        } catch (error) {
          console.error(error);
          /** enable button */
          jQuery("input[name='reg_button'][type='submit']").removeClass("disabledButton");
        }
        /** */
      } catch (error) {
        console.error(error);
        /** enable button */
        jQuery("input[name='reg_button'][type='submit']").removeClass("disabledButton");
      }
    } else {
      console.log(
        `ARR - No action. Current page: ${currentPageNumber} / Page to Action: ${window.RAC.config.pageToGenerateRecommendation}`
      );
    }
  } else {
    console.error("Library is not loaded or ATTENDEE_ID is not set.");
  }
})();
